<script setup>
import { ref, onMounted, inject } from 'vue';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';
import 'select2/dist/js/select2.min.js';
import authStore from '../store/auth';
import DateSelect from './components/DateSelect.vue';

import InvoiceTable from './components/InvoiceTable.vue';

const baseUrl = inject('baseUrl');

const selectedOption1 = ref(null);
const selectedOption2 = ref(null);
// const shedsOptions = ref([]);

const selectedRangeValue = ref('');
const selectedRange = ref([]);

const authState = authStore.state;

const select2Dropdown1 = ref(null);
const select2Dropdown2 = ref(null);

const staticOptions = [
  { id: 'all', text: 'All' }
];

onMounted(() => {
  // Fetch sheds data from the server
  $.ajax({
    url: baseUrl + '/get-sheds',
    method: 'GET',
    beforeSend: (xhr) => {
      xhr.setRequestHeader("Authorization", `Bearer ${authState.token}`);
    },
    success: (data) => {
      const combinedOptions = [
      ...staticOptions,
      ...data.map(shed => ({ id: shed.id, text: shed.name }))
    ];
      $(select2Dropdown2.value).select2({
        placeholder: 'Select an option',
        width: '100%',
        data: combinedOptions,
      }).on('change', (e) => {
        selectedOption2.value = $(e.target).val();
      });
    },
    error: (error) => {
      console.error('Error fetching sheds:', error);
    }
  });

  // Fetch vehicle numbers
  $.ajax({
    url: baseUrl + '/get-vehicle-numbers-for-select',
    method: 'GET',
    beforeSend: (xhr) => {
      xhr.setRequestHeader("Authorization", `Bearer ${authState.token}`);
    },
    success: (data) => {
      const combinedOptions = [
      ...staticOptions,
      ...data.map(vehicleNumber => ({ id: vehicleNumber, text: vehicleNumber }))
    ];
      $(select2Dropdown1.value).select2({
        placeholder: 'Select an option',
        width: '100%',
        data: combinedOptions,
      }).on('change', (e) => {
        selectedOption1.value = $(e.target).val();
      });
    },
    error: (error) => {
      console.error('Error fetching vehicle numbers:', error);
    }
  });

});
</script>

<template>
  <div class="py-4 container-fluid">
    <div class="row mb-4">
      <div class="col-md-4">
        <label class="form-label text-white">Vehicle Number</label>
        <select ref="select2Dropdown1" class="form-control">
          <option value="" disabled selected>Select an option</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-white">Sheds</label>
        <select ref="select2Dropdown2" class="form-control">
          <option value="" disabled selected>Select an option</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label text-white">Date Range</label>
        <DateSelect 
          @update:selectedRangeValue="selectedRangeValue = $event"
          @update:selectedRange="selectedRange = $event"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <InvoiceTable 
          :selectedShed="selectedOption2"
          :selectedVehicle="selectedOption1"
          :selectedDateRangeValue="selectedRangeValue"
          :selectedDateRange="selectedRange"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Add any custom styles you need */
</style>
